import { ApiProperty } from '../../codegen';
import { EStorageBucket } from '../../enums';
import { IsEnum, IsObject, IsOptional, IsString } from '../../validators';

export class FilesSignReturnDto {
  @ApiProperty()
  @IsString()
  url: string;

  @ApiProperty()
  @IsString()
  fileKey: string;

  @ApiProperty()
  @IsObject()
  fields: Record<string, string>;
}

export class SignDto {
  @ApiProperty()
  @IsOptional()
  @IsString({ groups: ['error'] })
  extension?: string;

  @ApiProperty({ required: false })
  @IsOptional({ groups: ['error'] })
  @IsEnum(EStorageBucket, { groups: ['error'] })
  bucket?: EStorageBucket;
}
